<template>
  <div>
    <b-card
      no-body
      class="my-1"
      :class="{ 'card-transparent-background': type == 'register' }"
    >
      <b-card-header
        class=""
        :class="{
          'card-header-profile-border': type == 'profile' || type == 'edit',
          'card-header-form-doorder': type == 'register',
        }"
        ><h4>Company Details</h4></b-card-header
      >

      <b-card-body
        class=""
        :class="{
          'p-2': type == 'profile' || type == 'edit',
          'py-0': type == 'register',
        }"
      >
        <div class="container">
          <b-row>
            <b-col sm="6">
              <b-form-group class="form-group-doorder"
                :label="type == 'register' ? '' : 'Company name'"
                label-for="company_name"
                :company_name="company_name"
                label-class="form-label-doorder"
                ><p
                  v-if="invalid_company_name "
                  class="error_validation_message_p"
                >
                  Please enter company name
                </p>
                <b-form-input
                  v-if="type == 'register' || type == 'edit'"
                  id="company_name"
                  class="form-control-doorder"
                  v-model="_company_name"
                  :company_name="company_name"
                  placeholder="Company name"
                  required
                ></b-form-input>
                <span
                  v-if="type == 'profile'"
                  class="form-control form-control-doorder"
                >
                  {{ _company_name }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group class="form-group-doorder"
                :label="type == 'register' ? '' : 'Company website'"
                label-for="company_website"
                :company_website="company_website"
                label-class="form-label-doorder"
              ><p
                  v-if="invalid_company_website"
                  class="error_validation_message_p"
                >
                  Please enter company website
                </p>
                <b-form-input
                  v-if="type == 'register' || type == 'edit'"
                  id="company_website"
                  class="form-control-doorder"
                  v-model="_company_website"
                  :company_website="company_website"
                  placeholder="Company website"
                  required
                ></b-form-input>
                <span
                  v-if="type == 'profile'"
                  class="form-control form-control-doorder"
                >
                  {{ _company_website }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group class="form-group-doorder"
                :label="type == 'register' ? '' : 'Business type'"
                label-for="business_type"
                :business_type="business_type"
                label-class="form-label-doorder"
              >
               <p
                  v-if="invalid_business_type"
                  class="error_validation_message_p"
                >
                  Please enter business type
                </p> <b-form-input
                  v-if="type == 'register' || type == 'edit'"
                  id="business_type"
                  class="form-control-doorder"
                  v-model="_business_type"
                  :business_type="business_type"
                  placeholder="Business type"
                  required
                ></b-form-input>
                <span
                  v-if="type == 'profile'"
                  class="form-control form-control-doorder"
                >
                  {{ business_type }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                :label="
                  type == 'register' ? '' : 'Number of business locations'
                "
                label-for="number_business_locations"
                :number_business_locations="number_business_locations"
                label-class="form-label-doorder"
              >
                <b-form-input
                  v-if="type == 'register' "
                  id="number_business_locations"
                  class="form-control-doorder"
                  type="number"
                  min="1"
                  v-model="_number_business_locations"
                  :number_business_locations="number_business_locations"
                  placeholder="Number of business locations"
                  required
                ></b-form-input>
                <span
                  v-else
                  class="form-control form-control-doorder"
                >
                  {{ number_business_locations }}
                </span>
                <!-- <span class="form-control form-control-doorder">
                  {{ number_business_locations }}
                </span> -->
              </b-form-group>
            </b-col>
            <b-col
              sm="6"
              v-if="
                (type == 'profile' && status == 'current') || type == 'edit'
              "
            >
              <b-form-group class="form-group-doorder"
                label="Retailer invoice reference number"
                label-for="invoice_reference_number"
                :invoice_reference_number="invoice_reference_number"
                label-class="form-label-doorder"
              >
               <p
                  v-if="invalid_invoice_reference_number"
                  class="error_validation_message_p"
                >
                  Please enter invoice reference number
                </p>
                <b-form-input
                  v-if="type == 'edit' || type == 'edit'"
                  id="invoice_reference_number"
                  class="form-control-doorder"
                  v-model="_invoice_reference_number"
                  :invoice_reference_number="invoice_reference_number"
                  placeholder="Retailer invoice reference number"
                ></b-form-input>
                <span
                  v-if="type == 'profile'"
                  class="form-control form-control-doorder"
                >
                  {{ _invoice_reference_number }}
                </span>
              </b-form-group>
            </b-col>
            <b-col
              sm="6"
              v-if="
                (type == 'profile' && status == 'current') || type == 'edit'
              "
            >
              <b-form-group
                label="QR label scan required"
                label-for="qr_scan_required"
                :qr_scan_required="qr_scan_required"
                label-class="form-label-doorder"
                class="form-group-switch-doorder"
              >
                <!-- <b-form-input
                  v-if="type == 'edit'"
                  id="qr_scan_required"
                  class="form-control-doorder"
                  v-model="_qr_scan_required"
                  :qr_scan_required="qr_scan_required"
                  required
                ></b-form-input> -->
                <!-- <b-form-checkbox
                  switch
                  size="lg"
                  v-model="_qr_scan_required"
                  :qr_scan_required="qr_scan_required"
                  id="qr_scan_required"
                  value="1"
                  unchecked-value="0"
                  :aria-describedby="ariaDescribedby"
                  ></b-form-checkbox
                > -->
                <toggle-button
                  :value="qr_scan_required"
                  :width="80"
                  :height="30"
                  :color="{ checked: '#e8ca49', unchecked: '#656565' }"
                  :sync="true"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  v-model="_qr_scan_required"
                  :disabled="type != 'edit'"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "CompanyDetails",
  props: [
    "type",
    "status",
    "company_name",
    "company_website",
    "business_type",
    "number_business_locations",
    "invoice_reference_number",
    "qr_scan_required",

    "invalid_company_name",
    "invalid_company_website",
    "invalid_business_type",
    "invalid_invoice_reference_number",
  ],
  data() {
    return {};
  },
  mounted(){
console.log(  this.invalid_company_name,
    this.invalid_company_website,
    this.invalid_business_type,
    this.invalid_invoice_reference_number)
  },
  computed: {
    _company_name: {
      get() {
        return this.company_name;
      },
      set(value) {
        this.$emit("update:company_name", value);
      },
    },
    _company_website: {
      get() {
        return this.company_website;
      },
      set(value) {
        this.$emit("update:company_website", value);
      },
    },
    _business_type: {
      get() {
        return this.business_type;
      },
      set(value) {
        this.$emit("update:business_type", value);
      },
    },
    _number_business_locations: {
      get() {
        return this.number_business_locations;
      },
      set(value) {
        this.$emit("update:number_business_locations", value);
      },
    },
    _invoice_reference_number: {
      get() {
        return this.invoice_reference_number;
      },
      set(value) {
        this.$emit("update:invoice_reference_number", value);
      },
    },
    _qr_scan_required: {
      get() {
        console.log(this.qr_scan_required);
        return this.qr_scan_required;
      },
      set(value) {
        console.log(value);
        this.$emit("update:qr_scan_required", value);
        console.log(this.qr_scan_required);
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doorder/retailers/profile_details_components/CompanyDetails.vue